<template>
  <div class="lanshou_box">
    <div class="lanshou_title_bg">
      <img src="/static/lanshouScreen/lanshou_title.png" width="100%" height="100%">
    </div>
    <div class="lanshou_title">
      <div style="flex: 1" />
      <div class="title">{{ $t('RouterObj.pickupServiceDashboard') }}</div>
      <div class="title_time">
        <div style="max-width: 260px;">
          {{ $t('GlobalSetObj.UpdateTime') }}：{{ updateTime }}
        </div>
      </div>
    </div>
    <div class="lanshou_search">
      <el-form size="small" label-position="top">
        <el-row :gutter="10">
          <el-col :span="6">
            <!--订单创建时间-->
            <el-form-item :label="$t('collectionCenter.orderCreateT')">
              <el-date-picker
                v-model="queryForm.queryDate"
                type="date"
                :clearable="false"
                style="width: 100%;"
                value-format="yyyy-MM-dd"
                :placeholder="$t('operationCenter.PleaseSelect')"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!--业务类型-->
            <el-form-item :label="$t('collectionCenter.businessT')">
              <el-select
                v-model="queryForm.businessType"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                style="width: 100%;"
              >
                <el-option key="all" :label="$t('GlobalSetObj.all')" :value="null" />
                <el-option key="FM" label="FM" value="FM" />
                <el-option key="SFS" label="SFS" value="SFS" />
                <el-option key="D2D" label="D2D" value="D2D" />
                <el-option key="快递" :label="$t('collectionCenter.expressDelivery')" value="快递" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!--客户名称-->
            <el-form-item :label="$t('collectionCenter.CustomerName')">
              <el-select
                v-model="queryForm.customerId"
                :placeholder="$t('spareNumberPoo.Only10AreDisplayed')"
                :remote-method="getCustomerPage"
                filterable
                remote
                style="width: 100%"
                @visible-change="getCustomerPage()"
              >
                <el-option key="all" :label="$t('GlobalSetObj.all')" :value="null" />
                <el-option
                  v-for="item in customerList"
                  :key="item.id"
                  :label="item.customerAlias + '(' + item.username + ')'"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <div class="lanshou_bottom" style="margin-top: 28px">
              <el-button
                type="text" class="search" size="small"
                @click="getData"
              >
                {{ $t('GlobalSetObj.search') }}
              </el-button>
              <el-button
                type="text" class="rest" size="small"
                @click="resetQuery"
              >{{ $t('GlobalSetObj.reset') }}</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="lanshou_content">
      <div style="flex: 1;">
        <div class="charts_content">
          <div class="charts_title_content">
            <img src="/static/lanshouScreen/lanshou_smill_title.png" width="100%" height="100%">
            <div class="charts_title">
              <!--商户数据展示-->
              {{ $t('collectionCenter.MerchantDataDisplay') }}
            </div>
          </div>
          <div id="merchantDataDisplay" style="height: 240px;width: 100%;" />
        </div>
      </div>
      <div style="flex: 1">
        <div class="charts_content">
          <div class="charts_title_content">
            <img src="/static/lanshouScreen/lanshou_smill_title.png" width="100%" height="100%">
            <div class="charts_title">
              <!--揽收环节-->
              {{ $t('collectionCenter.CollectionLink') }}
            </div>
          </div>
          <div id="collectionProcess" style="height: 240px;width: 100%;" />
        </div>
      </div>
      <div style="flex: 1">
        <div class="charts_content">
          <div class="charts_title_content">
            <img src="/static/lanshouScreen/lanshou_smill_title.png" width="100%" height="100%">
            <div class="charts_title">
              <!--签收环节-->
              {{ $t('collectionCenter.SigningLink') }}
            </div>
          </div>
          <div id="signInProcess" style="height: 240px;width: 100%;" />
        </div>
      </div>
    </div>
    <div class="lanshou_content_bottom charts_content">
      <div class="charts_title_content">
        <img src="/static/lanshouScreen/lanshou_item_title_bg.png" width="100%" height="100%">
        <div class="charts_title">
          <!--签收环节-->
          {{ $t('collectionCenter.KPIReached') }}
        </div>
      </div>
      <div style="display: flex;padding: 30px 20px;">
        <div class="lanshou_bottom_item">
          <div style="height: 140px;position:relative;">
            <img src="/static/lanshouScreen/lanshou_item_bg.png" height="100%">
            <div class="lanshou_bottom_item_day">{{ kpiAchievement.collectionTimeEfficiency }}{{ $t('orderCenterCont.days') }}</div>
          </div>
          <!--揽收时效-->
          <div class="lanshou_bottom_item_title">{{ $t('collectionCenter.CollectionTime') }}</div>
        </div>
        <div class="lanshou_bottom_item">
          <div style="height: 140px;position:relative;">
            <img src="/static/lanshouScreen/lanshou_item_bg.png" height="100%">
            <div class="lanshou_bottom_item_day">{{ kpiAchievement.arrivalTimeEfficiency }}{{ $t('orderCenterCont.days') }}</div>
          </div>
          <!--运抵时效-->
          <div class="lanshou_bottom_item_title">{{ $t('collectionCenter.prescriptionArrival') }}</div>
        </div>
        <div class="lanshou_bottom_item">
          <div style="height: 140px;position:relative;">
            <img src="/static/lanshouScreen/lanshou_item_bg.png" height="100%">
            <div class="lanshou_bottom_item_day">{{ kpiAchievement.spMetroArrivalTimeEfficiency }}{{ $t('orderCenterCont.days') }}</div>
          </div>
          <!--圣保罗市/大都市区运抵时效-->
          <div class="lanshou_bottom_item_title">{{ $t('collectionCenter.SaoPauloCityMetropolitanArea') }}</div>
        </div>
        <div class="lanshou_bottom_item">
          <div style="height: 140px;position:relative;">
            <img src="/static/lanshouScreen/lanshou_item_bg.png" height="100%">
            <div class="lanshou_bottom_item_day">{{ kpiAchievement.spCountrysideArrivalTimeEfficiency }}{{ $t('orderCenterCont.days') }}</div>
          </div>
          <!--圣保罗乡下运抵时效-->
          <div class="lanshou_bottom_item_title">{{ $t('collectionCenter.DeliveryTimeToSaoPauloCountryside') }}</div>
        </div>
        <div class="lanshou_bottom_item">
          <div style="height: 140px;position:relative;">
            <img src="/static/lanshouScreen/lanshou_item_bg.png" height="100%">
            <div class="lanshou_bottom_item_day">{{ kpiAchievement.otherStatesArrivalTimeEfficiency }}{{ $t('orderCenterCont.days') }}</div>
          </div>
          <!--外州运抵时效-->
          <div class="lanshou_bottom_item_title">{{ $t('collectionCenter.DeliveryTimeToOutsideTheState') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { CustomerPage } from '@/api/customer';
import * as echarts from 'echarts';
import { collectOrderDashboardData, getFormatServerTime } from '@/api/lanshou';
export default {
  data() {
    return {
      queryForm: {
        queryDate: '',
        businessType: null,
        customerId: null
      },
      kpiAchievement: {
        collectionTimeEfficiency: '', // 揽收时效
        arrivalTimeEfficiency: '', // 运抵时效
        spMetroArrivalTimeEfficiency: '', // 圣保罗市/大都市区运抵时效
        spCountrysideArrivalTimeEfficiency: '', // 圣保罗乡下运抵时效
        otherStatesArrivalTimeEfficiency: '' // 外州运抵时效
      },
      updateTime: null,
      customerList: [],
      merchantDataDisplay: null,
      collectionProcess: null,
      signInProcess: null,
      timer: null // 存储定时器引用
    };
  },
  mounted() {
    this.getCustomerPage();
    this.getBrazilTime();
  },
  activated() {
    this.queryForm = {
      queryDate: '',
      businessType: null,
      customerId: null
    };
    this.getBrazilTime();
    this.startPolling();
    window.addEventListener('resize', this.resizeCollectionKanban);
  },
  deactivated() {
    this.cleanup();
  },
  methods: {
    // 关闭定时轮询和监听窗口缩放
    cleanup() {
      this.stopPolling();
      window.removeEventListener('resize', this.resizeCollectionKanban);
    },
    // 定时轮询数据
    startPolling() {
      this.timer = setInterval(() => {
        console.log(111);
        this.getData(); // 每半小时执行一次请求
      }, 1800000); // 30分钟 = 1800000毫秒
    },
    // 停止轮询数据
    stopPolling() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    // 获取巴西当前时间
    getBrazilTime() {
      getFormatServerTime().then(res => {
        if (res.code === 200 && res.data) {
          console.log(res.data, '====res.data');
          this.queryForm.queryDate = res.data.split(' ')[0];
          this.getData();
        }
      });
    },
    // 获取客户列表
    getCustomerPage(name = '') {
      const param = {
        pageSize: 10,
        pageNumber: 1,
        params: {
          quickSearch: name
        }
      };
      CustomerPage(param, false).then((res) => {
        if (res.code === 200) {
          this.customerList = res.data.records;
        }
      });
    },
    // 查询数据
    getData() {
      const param = {
        queryDate: this.queryForm.queryDate,
        businessType: this.queryForm.businessType,
        customerId: this.queryForm.customerId
      };
      collectOrderDashboardData(param).then(res => {
        if (res.code === 200) {
          console.log(res, '====res');
          if (this.merchantDataDisplay) {
            this.merchantDataDisplay.clear();
          }
          if (this.collectionProcess) {
            this.collectionProcess.clear();
          }
          if (this.signInProcess) {
            this.signInProcess.clear();
          }
          // 商户数据展示
          const merchantDataDisplay = document.getElementById('merchantDataDisplay');
          this.merchantDataDisplay = echarts.init(merchantDataDisplay);
          const merchantData = [
            // 应揽收商家总数
            { value: res.data.merchantData.totalShouldCollectMerchant, name: this.$t('collectionCenter.TotalNumberOfMerchantsToBeCollected'), itemStyle: { color: '#2195fb' }},
            // 已完成商家总数
            { value: res.data.merchantData.completedMerchantCount, name: this.$t('collectionCenter.TotalNumberOfMerchantsCompleted'), itemStyle: { color: '#ff892b' }},
            // 未揽收商家总数
            { value: res.data.merchantData.uncollectedMerchantCount, name: this.$t('collectionCenter.TotalNumberOfMerchantsNotCollected'), itemStyle: { color: '#fe359b' }}
          ];
          // 揽收环节
          const collectionProcess = document.getElementById('collectionProcess');
          this.collectionProcess = echarts.init(collectionProcess);
          const collectionLink = [
            // 应揽收总量
            { value: res.data.collectionLink.totalShouldCollect, name: this.$t('collectionCenter.TotalAmountToBeCollected'), itemStyle: { color: '#2195fb' }},
            // 已揽收总量
            { value: res.data.collectionLink.totalCollected, name: this.$t('collectionCenter.TotalAmountCollected'), itemStyle: { color: '#ff892b' }},
            // 未揽收总量
            { value: res.data.collectionLink.totalUncollected, name: this.$t('collectionCenter.TotalAmountNotCollected'), itemStyle: { color: '#fe359b' }}
          ];
          const collectionRate = res.data.collectionLink.collectionRate;
          // 签收环节
          const signInProcess = document.getElementById('signInProcess');
          this.signInProcess = echarts.init(signInProcess);
          const signLink = [
            // 应收签收总数
            { value: res.data.signLink.totalShouldSign, name: this.$t('collectionCenter.TotalNumberOfExpectedSignatures'), itemStyle: { color: '#2195fb' }},
            // 已签收数量
            { value: res.data.signLink.totalSigned, name: this.$t('collectionCenter.TotalNumberOfSignatures'), itemStyle: { color: '#ff892b' }},
            // 未签收数量
            { value: res.data.signLink.totalUnSigned, name: this.$t('collectionCenter.TotalNumberOfSignaturesNotCollected'), itemStyle: { color: '#fe359b' }}
          ];
          const signRate = res.data.signLink.signRate;
          // kpi达成
          this.kpiAchievement = res.data.kpiAchievement;
          // 更新时间
          this.updateTime = res.data.updateTime;
          const option1 = {
            tooltip: {
              trigger: 'item',
              formatter: (params) => {
                const titleName = `${params.data.name}`;
                const title = titleName.match(/.{1,25}/g).join('<br>');
                return `${title}:<br>${params.data.value}`;
              }
            },
            legend: {
              orient: 'vertical',
              left: 10,
              top: 'middle',
              icon: 'circle',
              formatter: (name) => {
                const item = merchantData.find(item => item.name === name);
                const titleName = `${item.name}`;
                const title = titleName.match(/.{1,25}/g).join('\n');
                if (item) {
                  return title + `\n ${item.value}`;
                }
                return name;
              },
              textStyle: {
                fontSize: 13, // 设置字体大小
                color: '#fff' // 设置字体颜色
              },
              selectedMode: false
            },
            series: [
              {
                name: 'Access From',
                type: 'pie',
                center: ['75%', '50%'],
                radius: '50%',
                roseType: 'radius',
                data: merchantData,
                label: {
                  show: false,
                  position: 'center'
                },
                emphasis: {
                  itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                  }
                }
              }
            ]
          };
          const option2 = {
            title: {
              text: this.$t('collectionCenter.CollectionRate') + collectionRate + '%',
              left: '75%',
              textAlign: 'center',
              bottom: 30,
              textStyle: {
                color: '#fff',
                fontSize: 12,
                fontWeight: 'normal'
              }
            },
            tooltip: {
              trigger: 'item',
              formatter: (params) => {
                const titleName = `${params.data.name}`;
                const title = titleName.match(/.{1,25}/g).join('<br>');
                return `${title}:<br>${params.data.value}`;
              }
            },
            legend: {
              orient: 'vertical',
              left: 10,
              top: 'middle',
              icon: 'circle',
              formatter: (name) => {
                const item = collectionLink.find(item => item.name === name);
                const titleName = `${item.name}`;
                const title = titleName.match(/.{1,25}/g).join('\n');
                if (item) {
                  return title + `\n ${item.value}`;
                }
                return name;
              },
              textStyle: {
                fontSize: 13, // 设置字体大小
                color: '#fff' // 设置字体颜色
              },
              selectedMode: false
            },
            series: [
              {
                name: 'Access From',
                type: 'pie',
                center: ['75%', '50%'],
                radius: ['30%', '50%'],
                roseType: 'radius',
                data: collectionLink,
                label: {
                  show: true,
                  position: 'center',
                  formatter: (params) => {
                    return collectionRate + '%';
                  },
                  textStyle: {
                    textAlign: 'center',
                    color: '#fff',
                    rich: 'inherit'
                  }
                },
                emphasis: {
                  itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                  }
                }
              }
            ]
          };
          const option3 = {
            title: {
              text: this.$t('collectionCenter.RateOfSigning') + signRate + '%',
              left: '75%',
              textAlign: 'center',
              bottom: 30,
              textStyle: {
                color: '#fff',
                fontSize: 12,
                fontWeight: 'normal'
              }
            },
            tooltip: {
              trigger: 'item',
              formatter: (params) => {
                const titleName = `${params.data.name}`;
                const title = titleName.match(/.{1,25}/g).join('<br>');
                return `${title}:<br>${params.data.value}`;
              }
            },
            legend: {
              orient: 'vertical',
              left: 10,
              top: 'middle',
              icon: 'circle',
              formatter: (name) => {
                const item = signLink.find(item => item.name === name);
                const titleName = `${item.name}`;
                const title = titleName.match(/.{1,25}/g).join('\n');
                if (item) {
                  return title + `\n ${item.value}`;
                }
                return name;
              },
              textStyle: {
                fontSize: 13, // 设置字体大小
                color: '#fff' // 设置字体颜色
              },
              selectedMode: false
            },
            series: [
              {
                name: 'Access From',
                type: 'pie',
                center: ['75%', '50%'],
                radius: ['30%', '50%'],
                roseType: 'radius',
                data: signLink,
                label: {
                  show: true,
                  position: 'center',
                  formatter: (params) => {
                    return signRate + '%';
                  },
                  textStyle: {
                    textAlign: 'center',
                    color: '#fff',
                    rich: 'inherit'
                  }
                },
                emphasis: {
                  itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                  }
                }
              }
            ]
          };
          option1 && this.merchantDataDisplay.setOption(option1);
          option2 && this.collectionProcess.setOption(option2);
          option3 && this.signInProcess.setOption(option3);
        }
      });
    },
    // 重置查询
    resetQuery() {
      this.queryForm = {
        queryDate: '',
        businessType: null,
        customerId: null
      };
      this.getBrazilTime();
    },
    resizeCollectionKanban() {
      if (this.merchantDataDisplay) {
        this.merchantDataDisplay.resize();
      }
      if (this.collectionProcess) {
        this.collectionProcess.resize();
      }
      if (this.signInProcess) {
        this.signInProcess.resize();
      }
    }
  }
};
</script>
<style lang="scss">
.lanshou_box {
  position: absolute;
  width: 100%;
  height: 100%;
  color: #fff;
  background: url('/static/lanshouScreen/lanshou_bg.png') no-repeat;
  .lanshou_title_bg {
    height: 40px;
    width: 100%;
  }
  .lanshou_title {
    height: 40px;
    width: 100%;
    display: flex;
    margin-top: -40px;
    .title {
      flex: 1;
      text-align: center;
      line-height: 40px;
      font-size: 18px;
      font-weight: bold;
    }
    .title_time {
      flex: 1;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      font-size: 14px;
      padding-right: 10px;
    }
  }
  .lanshou_search {
    padding: 10px 20px;
    .el-form-item__label {
      color: #8ca6c3;
    }
    .el-input__inner {
      background-color: transparent !important;
      border: 1px solid #245a7a;
      color: #fff !important;
    }
    .el-input__inner:hover {
      border-color: #245a7a;
    }
    .el-input__inner::placeholder {
      color: #fff;
      opacity: 1;
    }
    .el-input__prefix,
    .el-input__suffix,
    .el-button--primary.is-plain:hover,
    .el-select .el-input .el-select__caret,
    .el-button--primary.is-plain:active,
    .el-button--primary.is-plain:focus
    {
      color: #245a7a;
    }
    .el-button--primary.is-plain {
      background-color: transparent;
      border-color: #245a7a;
    }
  }
  .lanshou_content {
    display: flex;
    margin: 0 10px;
  }
  .charts_content {
    border: 1px solid #17749f;
    border-radius: 3px;
    margin: 20px 10px;
  }
  .charts_title_content {
    width: 100%;
    height: 40px;
    margin-top: -6px;
    position: relative;
    .charts_title {
      font-size: 14px;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      line-height: 42px;
      padding: 0 10px;
    }
  }
  .lanshou_content_bottom {
    margin: 20px;
    .lanshou_bottom_item {
      flex: 1;
      display: flex;
      align-items: center;
      flex-direction: column;
      .lanshou_bottom_item_day {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .lanshou_bottom_item_title {
        background-image: url('/static/lanshouScreen/lanshou_item_title.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        margin: 20px 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 13px;
        line-height: 18px;
        padding: 10px;
      }
    }
  }
  .lanshou_bottom {
    .search.el-button--text {
      color: #fff;
      padding: 9px 15px;
      background: #005ebc;
    }
    .rest.el-button--text {
      padding: 9px 15px;
      color: #3585de;
      border: 1px solid #3585de;
    }
  }
}
</style>
